const GetFieldSuggest = async (keyword: string) => {
  try {
    const source =
      process.env.REACT_APP_COVEO_INDEX ?? "Coveo_web_index - devFeature";

    const header = new Headers({
      Authorization: `Bearer ${
        process.env.REACT_APP_COVEO_API_TOKEN ??
        "xx010cf958-c4ab-4d64-8ad8-5e074257d494"
      }`,
    });

    //        accessToken: 'xx87526554-97c4-4381-95e1-d33052f52ff4',// 'xx010cf958-c4ab-4d64-8ad8-5e074257d494',
    const requestOptions = {
      method: "GET",
      headers: header,
    };
    const showAllBrandsQueryParam = `("Middle Atlantic Products", "C2G", "Chief")`;
    const organizationId =
      process.env.REACT_APP_COVEO_ORG ??
      "legrandavbrandsnonproduction1aqj5fqf4";
    const field = "@computedproductnumber";
    const constantQueryOverride = `(@brandfacet==${showAllBrandsQueryParam}) AND (@z95xtemplatename=="Product Sku") AND (NOT @isz32xthirdz32xpartyz32xproduct==1) AND (@source=="${source}")`;
    const pattern = "*" + keyword + "*";
    const patternType = "wildcard"; // wildcard | regularexpression | editdistance | phonetic
    const searchHub = "General Product Search Hub";
    //const pipeline = 'General Product Search Hub'
    const sortCriteria = "nosort"; //occurrences | nosort
    const maximumNumberOfValues = 5;
    //const recommendation = 'RecommendedProducts'
    //const logicalIndex = 'RecommendedProducts'
    const params = `organizationId=${organizationId}&field=${field}&constantQueryOverride=${constantQueryOverride}&pattern=${pattern}&patternType=${patternType}&searchHub=${searchHub}&sortCriteria=${sortCriteria}&maximumNumberOfValues=${maximumNumberOfValues}`;

    const response = await fetch(
      `https://platform.cloud.coveo.com/rest/search/v2/values?${params}`,
      requestOptions,
    );

    const data = await response.text().then((text: any) => {
      const data = text && JSON.parse(text);
      //console.log('data', data)
      let index = 0;
      return (
        data.values &&
        data.values.map((v: { value: any }) => {
          index++;

          const regex = new RegExp(`(${keyword})`, "i");

          const replaced = v.value.replace(regex, "<span>$&</span>");

          return {
            highlightedValue: replaced,
            name: v.value,
            index: index,
          };
        })
      );
    });

    return data;
  } catch (error) {
    console.log(`getProduct error: ${error}`);
  }
};

export default GetFieldSuggest;
